export default "__VITE_ASSET__CveKkArd__"